export const LOCALES = {
  ENGLISH: 'en-US',
  FRENCH: 'fr-CA',
  REDACT_ENGLISH: 'redact_en-US',
  REDACT_FRENCH: 'redact_fr-CA',
};
